import Button from '@jetbrains/ring-ui/components/button/button'
import * as React from 'react'
import type {SyntheticEvent} from 'react'

import styles from './CommonForm.css'

type Props = {
  content: React.ReactNode
  submitButtonContent: React.ReactNode
  onSubmit: () => Promise<any>
  onSuccess: () => unknown
  onClose: () => unknown
  formRef: React.Ref<any>
  extraButtons?: React.ReactNode
}
export default function CommonForm({
  content,
  formRef,
  submitButtonContent,
  onSubmit,
  onSuccess,
  onClose,
  extraButtons,
}: Props) {
  const [loading, setLoading] = React.useState(false)
  const handleSubmit = React.useCallback(
    (e: SyntheticEvent) => {
      e.preventDefault()
      setLoading(true)
      return onSubmit().then(
        () => {
          setLoading(false)
          onSuccess()
        },
        () => {
          setLoading(false)
        },
      )
    },
    [setLoading, onSubmit, onSuccess],
  )
  const handleKeyDown = React.useCallback(
    (e: React.KeyboardEvent) => {
      if ((e.target as Element).classList.contains('submit-on-cmd-enter')) {
        if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
          handleSubmit(e)
        }
      }
    },
    [handleSubmit],
  )
  return (
    // handles key events from children
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <form onSubmit={handleSubmit} ref={formRef} onKeyDown={handleKeyDown}>
      {content}
      <div className={styles.buttons}>
        <Button className={styles.button} primary type="submit" loader={loading}>
          {submitButtonContent}
        </Button>
        <Button data-test="cancel" onClick={onClose}>
          {'Cancel'}
        </Button>
        {extraButtons}
      </div>
    </form>
  )
}
